/* Pure calculations. Shopify remains the authority for prices and discounts. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.IDCPacks = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function promotion(offer, config) {
    const s = offer.settings;
    return s.verified === true && s.discount_type !== 'none' && Number(s.discount_value) > 0 &&
      (s.method !== 'code' || !!s.code?.trim()) &&
      (s.discount_type === 'percent' || config.currency === config.presentment);
  }
  function quote(offer, subtotal, config) {
    let total = Math.max(0, Math.round(subtotal));
    if (promotion(offer, config)) {
      const value = Number(offer.settings.discount_value);
      if (offer.settings.discount_type === 'percent') total = Math.round(total * (1 - Math.min(100, value) / 100));
      if (offer.settings.discount_type === 'amount') total -= Math.round(value * 100);
      if (offer.settings.discount_type === 'total') total = Math.min(total, Math.round(value * 100));
    }
    total = Math.max(0, total);
    return { total, savings: Math.max(0, subtotal - total), promotional: promotion(offer, config) };
  }
  function eligible(cart, products) {
    const ids = new Set(products.map(p => String(p.id)));
    const items = (cart.items || []).filter(item => ids.has(String(item.product_id)) && !item.selling_plan_allocation && !item.gift_card);
    return { items, quantity: items.reduce((n, i) => n + i.quantity, 0), subtotal: items.reduce((n, i) => n + (i.original_line_price ?? i.price * i.quantity), 0) };
  }
  function aggregate(selections, products, cart) {
    const variants = new Map(products.flatMap(p => p.variants).map(v => [String(v.id), v]));
    const counts = new Map();
    selections.forEach(id => {
      const v = variants.get(String(id));
      if (!v || !v.available) throw new Error('selection');
      counts.set(String(id), (counts.get(String(id)) || 0) + 1);
    });
    return Array.from(counts, ([id, quantity]) => {
      const v = variants.get(id);
      const existing = (cart.items || []).filter(i => String(i.variant_id) === id && !i.selling_plan_allocation).reduce((n, i) => n + i.quantity, 0);
      const total = existing + quantity;
      if (total < (v.min || 1) || (v.max != null && total > v.max) || total % (v.increment || 1)) throw new Error('quantity');
      return { id: Number(id), quantity };
    });
  }
  function codes(cart, code) {
    const current = (cart.discount_codes || []).map(x => x.code);
    for (const item of cart.items || []) for (const a of item.line_level_discount_allocations || []) {
      if (a.discount_application?.type === 'discount_code') current.push(a.discount_application.title);
    }
    for (const a of cart.cart_level_discount_applications || []) if (a.type === 'discount_code') current.push(a.title);
    return [...new Set([...current, code].filter(Boolean).map(x => x.trim()).filter(Boolean))].join(',');
  }
  return { promotion, quote, eligible, aggregate, codes };
});
